"use client";

/**
 * 入力の必要性。表示規約＝必須は実線枠＋白背景、任意は点線枠＋背景透過（ペイン地が透ける）。
 * 見た目のみの規約で、保存/実行ボタンの enable/disable はロジック側が担う。
 */
export type InputRequirement = "required" | "optional";

type Props = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    id?: string;
    type?: "text" | "search";
    /** sm=コンパクト（ツールバー）／md=標準（フォーム）／lg=見出し入力（タイトル）。 */
    size?: "sm" | "md" | "lg";
    fullWidth?: boolean;
    /** 必須=実線枠＋白背景／任意=点線枠＋背景透過。既定は必須。 */
    requirement?: InputRequirement;
    /** 文脈用の追加クラス（flex-1 等。枠線・背景は requirement で表す）。 */
    className?: string;
    ariaLabel?: string;
};

const SIZE: Record<"sm" | "md" | "lg", string> = {
    sm: "px-2 py-1 text-xs",
    md: "px-2 py-1 text-sm",
    lg: "px-2 py-1 text-lg font-semibold",
};

/** requirement → 枠線スタイル＋背景。必須=実線＋白、任意=点線＋透過。 */
export const REQUIREMENT_CLASS: Record<InputRequirement, string> = {
    required: "border-solid border-border-subtle bg-surface",
    optional: "border-dashed border-border-subtle bg-transparent",
};

/** ②のテキスト入力。requirement で枠線・背景を切り替える。focus:border-text-muted。size/className で文脈に合わせる。 */
export function TextInput({
    value,
    onChange,
    placeholder,
    disabled,
    id,
    type = "text",
    size = "md",
    fullWidth,
    requirement = "required",
    className = "",
    ariaLabel,
}: Props) {
    return (
        <input
            id={id}
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            aria-label={ariaLabel}
            className={`rounded border ${REQUIREMENT_CLASS[requirement]} text-text-primary placeholder:text-text-muted outline-none focus:border-text-muted disabled:opacity-50 ${SIZE[size]} ${fullWidth ? "w-full" : ""} ${className}`}
        />
    );
}
